module.exports = __webpack_public_path__ + "media/wrong_code.990a625c.wav";